import React, { ReactNode } from 'react'
import { Container, OuterPadding } from '@styles/global/helpers'
import styled from 'styled-components'
import { MMH2 } from '@styles/global/headlines'

interface IProps {
  headline: string
  description: string
  backgroundColor: string
  textColor: string
  headlineColor?: string
  ImageComponent: ReactNode
  headlineCss?: string
}

function Section3({ headline, headlineCss, description, backgroundColor, textColor, ImageComponent, headlineColor }: IProps) {
  return (
    <OuterPadding backgroundColor={backgroundColor}>
      <Container>
        {ImageComponent}
      </Container>

      <ContentContainer>
        <MMH2 textColor={textColor} headlineColor={headlineColor}>
          <h2 className={headlineCss}>
            {headline}
          </h2>
          <p>{description}</p>
        </MMH2>
      </ContentContainer>
    </OuterPadding>
  )
}

const ContentContainer = styled(Container)`
  padding-top: 3%;
`

export default Section3
